import React from 'react';
import {
  ArrowRight,
  Bot,
  Boxes,
  Code2,
  Lightbulb,
} from 'lucide-react';

const services = [
  {
    title: 'Consultoria',
    description:
      'Analisamos os desafios do seu negócio, identificando oportunidades de melhoria e definindo a estratégia tecnológica mais adequada para alcançar resultados.',
    icon: Lightbulb,
  },
  {
    title: 'Desenvolvimento',
    description:
      'Desenvolvemos sistemas web, aplicativos móveis e plataformas corporativas sob medida, utilizando tecnologias modernas e arquitetura preparada para crescer.',
    icon: Code2,
  },
  {
    title: 'Automação e Inteligência Artificial',
    description:
      'Automatizamos processos, integramos sistemas e aplicamos Inteligência Artificial para reduzir tarefas repetitivas, apoiar decisões e criar soluções mais inteligentes para empresas e órgãos públicos.',
    icon: Bot,
  },
  {
    title: 'Arquitetura de Software',
    description:
      'Projetamos soluções corporativas robustas, escaláveis e seguras, preparadas para sustentar operações críticas e acompanhar a evolução do seu negócio.',
    icon: Boxes,
  },
];

const ServicesSection = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');

    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      return;
    }

    window.location.href = '/#contact';
  };

  return (
    <section id="services" className="relative overflow-hidden bg-slate-950 py-24 lg:py-32">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(8,145,178,0.10),_transparent_42%)]" />

      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto mb-14 max-w-4xl text-center lg:mb-16">
          <span className="inline-flex rounded-full border border-cyan-500/20 bg-cyan-500/10 px-4 py-1.5 text-sm font-medium text-cyan-400">
            Nossos serviços
          </span>

          <h2 className="mt-6 text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Tecnologia aplicada aos desafios do seu negócio.
          </h2>

          <p className="mx-auto mt-6 max-w-3xl text-lg leading-8 text-slate-400">
            Projetamos e desenvolvemos soluções corporativas que combinam tecnologia, automação e Inteligência Artificial para acelerar a transformação digital das organizações.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {services.map(({ title, description, icon: Icon }) => (
            <article
              key={title}
              className="group rounded-2xl border border-slate-700/70 bg-slate-900/45 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-cyan-500/35 hover:bg-slate-900/70 lg:p-8"
            >
              <div className="flex items-start gap-5">
                <div className="grid h-14 w-14 flex-none place-items-center rounded-2xl border border-cyan-500/20 bg-cyan-500/10 text-cyan-400 transition-colors duration-300 group-hover:border-cyan-400/40 group-hover:bg-cyan-500/15">
                  <Icon className="h-7 w-7" strokeWidth={1.8} />
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-white lg:text-2xl">{title}</h3>
                  <p className="mt-3 text-base leading-7 text-slate-400">{description}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <button
            type="button"
            onClick={scrollToContact}
            className="inline-flex items-center justify-center gap-3 rounded-xl bg-gradient-to-r from-cyan-500 to-teal-500 px-7 py-3.5 font-semibold text-slate-950 shadow-[0_12px_35px_rgba(6,182,212,0.20)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_16px_45px_rgba(6,182,212,0.28)]"
          >
            Solicitar orçamento
            <ArrowRight className="h-5 w-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;